import script from "./createAssignment.vue?vue&type=script&setup=true&lang=js"
export * from "./createAssignment.vue?vue&type=script&setup=true&lang=js"

import "./createAssignment.vue?vue&type=style&index=0&id=f3da4c46&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3da4c46"]])

export default __exports__